import React, { useContext, useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Spinner,
  Card,
  Badge,
  Button,
} from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import {
  FaArrowLeft,
  FaStore,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaStar,
  FaTag,
  FaCheckCircle,
  FaMoneyBillWave,
  FaShoppingBag,
} from "react-icons/fa";
import axios from "axios";

import "../../../../assets/css/user/shops/shopdetailpage1/shopdetailpage1.css";
import AppContext from "../../../../context/AppContext";
import MyNavbar from "../../../../components/user/navbar/Navbar";
import MarqueeBanner from "../../../../components/user/Marqueebanner/Marqueebanner";
import SimpleBanner from "../../../../components/user/general/SimpleBanner";
import Footer from "../../../../components/user/footer/Footer";

const ShopDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);

  const [shop, setShop] = useState(null);
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchShopDetail = () => {
    setLoading(true);

    axios
      .get(`${baseUrl}/customer/shop/fetchSingleShop/${id}`)
      .then((response) => {
        console.log("SHOP DETAIL:", response.data);

        if (response.data.success) {
          setShop(response.data.shop);
          setDeals(response.data.deals || []);
        }
      })
      .catch((error) => {
        console.log("SHOP DETAIL ERROR:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (id) {
      fetchShopDetail();
    }
  }, [id]);

  if (loading) {
    return (
      <div className="shop-detail-loading">
        <Spinner animation="border" />
        <p>Loading shop...</p>
      </div>
    );
  }

  if (!shop) {
    return (
      <div className="shop-detail-not-found">
        <h3>Shop not found</h3>

        <Button onClick={() => navigate("/shop")}>Back to Shops</Button>
      </div>
    );
  }

  // =========================
  // RATING
  // =========================

  const rating = Number(shop.tpshoprating_avg_rating || 0);

  const reviewCount = Number(shop.tpshoprating_count || 0);

  // =========================
  // AVAILABLE DEALS
  // =========================

  const availableDeals = deals.filter(
    (deal) => String(deal.status || "").toLowerCase() !== "sold",
  );

  return (
    <>
      <MarqueeBanner />
      <MyNavbar />
      <SimpleBanner
        title="Brower Shops"
        subtitle="Discover verified sellers and their deals"
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "browershop", href: "/shop" },
        
        ]}
      />
      <Container fluid>
        {/* =========================================
            BACK BUTTON
        ========================================= */}
        <div className="shop-detail-page">
          <div className="shop-detail-back">
            <button onClick={() => navigate("/shop")}>
              <FaArrowLeft />
              Back to Shops
            </button>
          </div>

          {/* =========================================
            SHOP HEADER
        ========================================= */}

          <div className="shop-detail-header">
            <div className="shop-detail-avatar">
              {shop.shopname?.charAt(0)?.toUpperCase()}
            </div>

            <div className="shop-detail-header-info">
              <div className="shop-detail-title-row">
                <h1>{shop.shopname}</h1>

                {shop.verified && <FaCheckCircle className="verified-shop" />}
              </div>

              <div className="shop-detail-category">
                <FaStore />
                {shop.businessCategory || "Business"}
              </div>

              {/* RATING */}

              <div className="shop-detail-rating">
                <span className="rating-stars">
                  <FaStar />
                </span>

                <strong>{rating.toFixed(1)}/5</strong>

                <span>({reviewCount} Reviews)</span>
              </div>
            </div>
          </div>

          {/* =========================================
            SHOP INFORMATION
        ========================================= */}

          <div className="shop-information">
            <div className="section-heading">
              <h2>Shop Information</h2>
              <p>Complete information about this shop</p>
            </div>

            <Row className="g-3">
              <Col md={6} lg={4}>
                <div className="shop-info-card">
                  <div className="shop-info-icon">
                    <FaStore />
                  </div>

                  <div>
                    <small>Shop Name</small>
                    <strong>{shop.shopname || "-"}</strong>
                  </div>
                </div>
              </Col>

              <Col md={6} lg={4}>
                <div className="shop-info-card">
                  <div className="shop-info-icon">
                    <FaTag />
                  </div>

                  <div>
                    <small>Business Category</small>
                    <strong>{shop.businessCategory || "-"}</strong>
                  </div>
                </div>
              </Col>

              <Col md={6} lg={4}>
                <div className="shop-info-card">
                  <div className="shop-info-icon">
                    <FaMapMarkerAlt />
                  </div>

                  <div>
                    <small>Business Address</small>
                    <strong>
                      {shop.businessAddress || shop.shopaddress || "-"}
                    </strong>
                  </div>
                </div>
              </Col>

              <Col md={6} lg={4}>
                <div className="shop-info-card">
                  <div className="shop-info-icon">
                    <FaPhone />
                  </div>

                  <div>
                    <small>Phone</small>
                    <strong>{shop.phone || "-"}</strong>
                  </div>
                </div>
              </Col>

              <Col md={6} lg={4}>
                <div className="shop-info-card">
                  <div className="shop-info-icon">
                    <FaEnvelope />
                  </div>

                  <div>
                    <small>Email</small>
                    <strong>{shop.email || "-"}</strong>
                  </div>
                </div>
              </Col>

              <Col md={6} lg={4}>
                <div className="shop-info-card">
                  <div className="shop-info-icon">
                    <FaMoneyBillWave />
                  </div>

                  <div>
                    <small>Shop Review</small>
                    <strong>({reviewCount} Reviews)</strong>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          {/* =========================================
            SHOP STATS
        ========================================= */}

          <div className="shop-stats">
            <div className="shop-stat">
              <FaStar />

              <div>
                <strong>{rating.toFixed(1)}/5</strong>

                <span>Rating</span>
              </div>
            </div>

            <div className="shop-stat">
              <FaShoppingBag />

              <div>
                <strong>{availableDeals.length}</strong>

                <span>Available Deals</span>
              </div>
            </div>

            <div className="shop-stat">
              <FaTag />

              <div>
                <strong>{deals.length}</strong>

                <span>Total Deals</span>
              </div>
            </div>
          </div>

          {/* =========================================
            DEALS
        ========================================= */}

          <div className="shop-deals-section">
            <div className="section-heading deals-heading">
              <div>
                <h2>Deals from {shop.shopname}</h2>

                <p>Explore all available deals from this shop</p>
              </div>

              <Badge>{availableDeals.length} Deals</Badge>
            </div>

            {availableDeals.length > 0 ? (
              <Row className="g-4">
                {availableDeals.map((deal) => (
                  <Col key={deal.id} xs={12} md={6} lg={4}>
                    <Card className="shop-deal-card">
                      {/* IMAGE */}

                      <div className="shop-deal-image">
                        {deal.deal_image ? (
                          <img
                            src={`${baseUrlForFiles}/${deal.deal_image}`}
                            alt={deal.deal_title}
                          />
                        ) : (
                          <div className="no-deal-image">
                            <FaTag />
                          </div>
                        )}

                        {/* DISCOUNT */}

                        {deal.discount_percentage && (
                          <span className="deal-discount">
                            {deal.discount_percentage}% OFF
                          </span>
                        )}
                      </div>

                      {/* BODY */}

                      <Card.Body>
                        <div className="deal-type">
                          {deal.deal_type || "Deal"}
                        </div>

                        <Card.Title>{deal.deal_title}</Card.Title>

                        <Card.Text>{deal.description}</Card.Text>

                        {/* PRICE */}

                        <div className="deal-price">
                          {deal.deal_actualprice && (
                            <span className="deal-old-price">
                              Rs. {deal.deal_actualprice}
                            </span>
                          )}

                          <strong>Rs. {deal.deal_price}</strong>
                        </div>

                        {/* LOCATION */}

                        {deal.deal_location && (
                          <div className="deal-location">
                            <FaMapMarkerAlt />
                            {deal.deal_location}
                          </div>
                        )}

                        {/* VIEW BUTTON */}

                        <Button
                          className="view-deal-btn"
                          onClick={() => navigate(`/deal-details/${deal.id}`)}
                        >
                          View Deal
                          <span>→</span>
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            ) : (
              <div className="no-deals">
                <FaShoppingBag />

                <h4>No Deals Available</h4>

                <p>This shop currently has no available deals.</p>
              </div>
            )}
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default ShopDetail;
